module.exports = __webpack_public_path__ + "img/contact-toolbar-dark.66679fcd.png";